import React from 'react'

import { usePlaceType } from '../../_context/PlaceTypeContext'
import PlaceFiltersList from '../../../../containers/places/filters/PlaceFiltersList'
import ScreenViewFilterBar from '../../../../containers/screenViews/ScreenViewFilterBar'

const FiltersBar = ({ open }) => {
  const placeType = usePlaceType()

  return (
    <ScreenViewFilterBar screen={placeType} open={open}>
      <PlaceFiltersList types={placeType} />
    </ScreenViewFilterBar>
  )
}

export default FiltersBar
